import { h, Component } from 'preact';
import { sortObjectByOrder, joinClasses } from 'utils/utils';

import s from 'components/bolt/uarHeader/components/socials/socials.sss';

export default class Socials extends Component {
	render({ data, extraClass }) {
		const socials = data?.socials;
		return (
			<div class={joinClasses(s.socials, extraClass)}>
				{sortObjectByOrder(socials).map(element => {
					return <a target={'_blank'} href={element.path} class={s.socialLink}><div style={`--iconImage: url(${element.icon}); --iconHoverImage: url(${element.iconHover});`} class={s.socialIcon} /></a>;
				})}
			</div>
		);
	}
}